import $api from "../Api";
import Endpoints from "../Endpoints";

const normalizeSuccess = (response) => {
  if (response?.isSuccess === true && response.message === "OK")
    return response;
  if (response?.result === "OK" && response?.isSuccess !== false) {
    return { ...response, message: "OK", isSuccess: true };
  }
  return {
    ...response,
    message: response?.message || "FAIL",
    isSuccess: false,
    data: null,
  };
};

/**
 * Merkezi backfill seçimini kuyruğa alır.
 * @param {{
 *   productTagData?: boolean,
 *   checkoutPackageSales?: boolean,
 *   checkoutQuantitySummaries?: boolean,
 *   checkoutFinancialSnapshots?: boolean,
 *   crmCustomerLinks?: boolean,
 *   crmCustomerConvertedDates?: boolean,
 *   crmDefaultTags?: boolean,
 *   crmCustomerCampaignRelations?: boolean,
 *   leadCampaignTypes?: boolean,
 *   locationData?: boolean,
 *   locationStatisticsStartDate?: string,
 *   locationStatisticsEndDate?: string,
 *   forceRecalculate?: boolean,
 * }} form
 */
export const Start = async (form) => {
  const response = await $api.post(Endpoints.Backfill.Start(), form);
  return normalizeSuccess(response);
};

/**
 * Backfill iş durumunu getirir.
 * @param {{ params: { jobId: string }, query?: object }} option
 */
export const GetById = async (option) => {
  const response = await $api.get(Endpoints.Backfill.GetById(option));
  return normalizeSuccess(response);
};

export default {
  Start,
  GetById,
};
